import React, { useEffect, useState } from 'react';
import {
    TextField, FormControl, InputLabel, Grid, Paper,
    useMediaQuery, Button, FormHelperText, Table, TableBody, TableCell, TableContainer, Typography,
    TableRow, Autocomplete, TextareaAutosize, Checkbox

} from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import styled, { cutDates, inputStyles, stockNumber } from '../../Utils/inputChanges';
import { useDispatch, useSelector } from 'react-redux';
import { errorStyles } from '../../Utils/table';
import { fetchStitchContraReturn, fetchStitchContReGrp, fetchStitchingReturnlist, fetchStitchReturnGrpStid, fetchStitchReturnGrpStid2 } from '../../Store/PHPSlice/Stitching/StitchApi';
import { selectContCuttingReMemo, selectStitchContraReturn, selectStitchContReGrp, selectStitchReGrpStId, selectStitchReGrpStId2, selectStitchReturn, selectStitchReturnMemo, selectStkBarcode, selectStockMemoNo } from '../Selectors/StitchSelector/StitchingSelectors';
import { getCurrentDate } from '../../Utils/Dateutils';
import TitleBar from '../TitleBar';
import { StockMenu } from '../TitleList';
import { fetchDepartmentData } from '../../Store/PHPSlice/Department';
import { selectDaparement } from '../Selectors/Master/MasterSelectors';
import { fetchContractorReGrplist2, fetchContractorReturnlist } from '../../Store/PHPSlice/Cutting/cuttingApi';
import { selectContReGrplist2, selectContReturnlist } from '../Selectors/Master/ItemSelectors';
import { fetchStitchReturnMemo } from '../../Store/PHPSlice/Kaje/KajeApi';
import { fetchContCuttingRetMemo, fetchStockMemoNo, insertStockEntryProduction } from '../../Store/PHPSlice/Stock/StockApis';
import Dropdown from '../FieldsComponents/Dropdown';
import DateInputComponent from '../FieldsComponents/DateInputComponent';



const StkProductionEntry = () => {

    const [formData, setFormData] = useState({
        dt: getCurrentDate(),
        stkMemo: '',
        departNm: '',
        departId: '',
        streId: '',
        cutreId: '0',
        stchtopk: '',
        item: '',
        itemId: '',
        icode: '',
        empNm: '',
        empId: '',
        mcloth: '',
        m1cloth: '',
        m2cloth: '',
        m3cloth: '',
        soId: '',
        sono: '',
        totQty: '',
        instructions: '',
        clothNm: '',
        model: '',
        shadeNo: '',
        color: '',
        userId: '1'
    });
    const [infoData, setInfoData] = useState([]);
    const [rbqty, setRbqty] = useState([]);
    const dispatch = useDispatch();
    const departlist = useSelector(selectDaparement);
    const stkmemo = useSelector(selectStockMemoNo);
    const stitchingMemo = useSelector(selectStitchReturnMemo);
    const contCuttingRetMemo = useSelector(selectContCuttingReMemo);

    const StitchingReturnInfo = useSelector(selectStitchReGrpStId);
    // const StitchToPackInfo = useSelector(selectStitchContraReturn);
    const CutToPackInfo = useSelector(selectContReGrplist2);

    useEffect(() => {
        dispatch(fetchDepartmentData());
        dispatch(fetchStockMemoNo());
        dispatch(fetchStitchReturnMemo());
        dispatch(fetchContCuttingRetMemo());
    }, [dispatch]);

    useEffect(() => {
        if (StitchingReturnInfo?.Info?.length > 0) {
            const data = StitchingReturnInfo.Info.flatMap(subArray => {
                return subArray.map(obj => obj);
            });

            const info_data = consolidateData(data);
            setInfoData(info_data);
        }
    }, [StitchingReturnInfo]);


    useEffect(() => {
        if (CutToPackInfo?.returnInfo?.length > 0) {
            const data2 = CutToPackInfo.returnInfo.flatMap(subArray => {
                return subArray.map(obj => obj);
            });

            const info_data = consolidateData(data2);
            setInfoData(info_data);
        }
    }, [CutToPackInfo]);

    useEffect(() => {
        if (stkmemo?.data) {
            const item = stkmemo?.data?.stkMemo;
            setFormData(prev => ({
                ...prev,
                stkMemo: item
            }))
        }
    }, [stkmemo]);

    useEffect(() => {
        if (StitchingReturnInfo && StitchingReturnInfo?.data && StitchingReturnInfo.data.length > 0) {
            const item = StitchingReturnInfo.data[0];
            setFormData(prev => ({
                ...prev,
                empId: item.empId,
                empNm: item.empNm,
                itemId: item.itemId,
                item: item.itemNm,
                mcloth: item.mcloth,
                m1cloth: item.m1cloth,
                m2cloth: item.m2cloth,
                m3cloth: item.m3cloth,
                soId: item.soId,
                sono: item.sono,
                clothNm: item.mclothNm,
                model: item.model,
                color: item.mColor,
                shadeNo: item.shadeNo,
                icode: item.icode
            }));
        }
    }, [StitchingReturnInfo]);

    // useEffect(() => {
    //     if (StitchingReturnInfo && StitchingReturnInfo?.Info && StitchingReturnInfo.Info.length > 0) {
    //         // Filter out items where rbqty is 0
    //         const infoWithBarcode = StitchingReturnInfo.Info
    //             .filter(item => item.rbqty !== '0')  // Filter items where rbqty is not 0
    //             .map((item, index) => {
    //                 return {
    //                     ...item,  // Spread existing properties
    //                     barcode: parseInt(formData.stkBarcode) + index, // Add new barcode property
    //                     departNm: formData.departNm
    //                 };
    //             });

    //         setInfoData(infoWithBarcode);

    //         // Extract only the rbqty values for non-zero quantities
    //         const onlyqty = infoWithBarcode.map(item => item.rbqty);
    //         setRbqty(onlyqty);
    //     }

    // }, [StitchingReturnInfo]);

    useEffect(() => {
        if (CutToPackInfo && CutToPackInfo?.data && CutToPackInfo.data.length > 0) {
            const item = CutToPackInfo.data[0];
            setFormData(prev => ({
                ...prev,
                empId: item.empId,
                empNm: item.empNm,
                itemId: item.itemId,
                item: item.itemNm,
                mcloth: item.mcloth,
                m1cloth: item.m1cloth,
                m2cloth: item.m2cloth,
                m3cloth: item.m3cloth,
                soId: item.soId,
                sono: item.sono,
                clothNm: item.mclothNm,
                model: item.model,
                color: item.mColor,
                shadeNo: item.shadeNo,
                icode: item.icode
            }));
        }
    }, [CutToPackInfo]);

    // useEffect(() => {
    //     if (CutToPackInfo && CutToPackInfo?.returnInfo && CutToPackInfo.returnInfo.length > 0) {

    //         const infoWithBarcode = CutToPackInfo.returnInfo
    //             .filter(item => item.rbqty !== '0')  // Filter items where rbqty is not 0
    //             .map((item, index) => {
    //                 return {
    //                     ...item,  // Spread existing properties
    //                     barcode: parseInt(formData.stkBarcode) + index, // Add new barcode property
    //                     departNm: formData.departNm
    //                 };
    //             });

    //         setInfoData(infoWithBarcode);
    //         const onlyqty = infoWithBarcode.map(item => item.rbqty);
    //         setRbqty(onlyqty);
    //     }
    // }, [CutToPackInfo]);

    // useEffect(() => {
    //     if (StitchToPackInfo && StitchToPackInfo?.data && StitchToPackInfo.data.length > 0) {
    //         const item = StitchToPackInfo.data[0];

    //         setFormData(prev => ({
    //             ...prev,
    //             empId: item.empId,
    //             empNm: item.empNm,
    //             itemId: item.itemId,
    //             item: item.itemNm,
    //             mcloth: item.mcloth,
    //             m1cloth: item.m1cloth,
    //             m2cloth: item.m2cloth,
    //             m3cloth: item.m3cloth,
    //             soId: item.soId,
    //             sono: item.sono,
    //             clothNm: item.clothNm,
    //             model: item.model,
    //             color: item.color,
    //             shadeNo: item.shadeNo
    //         }));
    //     }
    // }, [StitchToPackInfo]);

    // useEffect(() => {
    //     if (StitchToPackInfo && StitchToPackInfo?.Info && StitchToPackInfo.Info.length > 0) {

    //         const infoWithBarcode = StitchToPackInfo.Info
    //             .filter(item => item.rbqty !== '0')  // Filter items where rbqty is not 0
    //             .map((item, index) => {
    //                 return {
    //                     ...item,  // Spread existing properties
    //                     barcode: parseInt(formData.stkBarcode) + index, // Add new barcode property
    //                     departNm: formData.departNm
    //                 };
    //             });

    //         setInfoData(infoWithBarcode);
    //         const onlyqty = infoWithBarcode.map(item => item.rbqty);
    //         setRbqty(onlyqty);
    //     }
    // }, [StitchToPackInfo]);

    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement
    // For filteredDepart:
    const filteredDepart = (departlist?.data && Array.isArray(departlist.data) && departlist.data.length > 0)
        ? departlist.data.filter(item => item.departNm === 'CUT-TO-PACK' || item.departNm === 'STITCH-TO-PACK' || item.departNm === 'STITCHING')
        : [];

    const filteredStitchingReturn = (stitchingMemo?.data && Array.isArray(stitchingMemo.data) && stitchingMemo.data.length > 0)
        ? stitchingMemo.data : [];

    const filteredStitchtoPack = (stitchingMemo?.stContRetMemo && Array.isArray(stitchingMemo.stContRetMemo) && stitchingMemo.stContRetMemo.length > 0)
        ? stitchingMemo.stContRetMemo : [];

    const filteredCutToPack = (contCuttingRetMemo?.data && Array.isArray(contCuttingRetMemo.data) && contCuttingRetMemo.data.length > 0)
        ? contCuttingRetMemo.data : [];


    function consolidateData(data) {
        return data.reduce((acc, curr) => {
            // Find if the size already exists in the accumulator
            const existing = acc.find(item => item.size === curr.size);

            if (existing) {
                // If it exists, sum up the numeric values
                existing.rqty += Number(curr.rqty);
                existing.dqty += Number(curr.dqty);
                existing.rbqty += Number(curr.rbqty);
            } else {
                // If no exact match, check for any existing object
                const previous = acc[acc.length - 1]; // Get the last added object
                const newObject = previous
                    ? {
                        ...previous, // Clone the previous object
                        size: curr.size, // Update size with current size
                        rqty: Number(curr.rqty),
                        dqty: Number(curr.dqty),
                        rbqty: Number(curr.rbqty)
                    }
                    : {
                        // If no previous object, create a new one
                        size: curr.size,
                        issqty: curr.issqty,
                        rqty: Number(curr.rqty),
                        dqty: Number(curr.dqty),
                        rbqty: Number(curr.rbqty)
                    };

                acc.push(newObject);
            }

            return acc;
        }, []);
    }

    const handleDateChange = (e) => {
        setFormData({
            ...formData,
            dt: e.target.value
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });
    };

    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;
        setFormData({
            ...formData,
            [dropdownType]: value
        });
        switch (dropdownType) {
            case 'streId':
                if (value) {
                    dispatch(fetchStitchReturnGrpStid(value));
                } else if (value === '') {
                    setInfoData([]);
                }
                break;
            case 'cutreId':
                if (value) {
                    dispatch(fetchContractorReGrplist2(value));
                } else if (value === '') {
                    setInfoData([]);
                }
                break;
            case 'stchtopk':
                if (value) {
                    dispatch(fetchStitchReturnGrpStid(value));
                } else if (value === '') {
                    setInfoData([]);
                }
                break;
        }
    };

    const handleQuantityChange = (index, value) => {
        // Ensure the value is a valid number and contains only digits (or is empty)
        if (value === '' || /^\d+$/.test(value)) {
            const numericValue = value === '' ? 0 : Number(value); // If empty, set to 0, otherwise convert to number

            // Default quantity (you may use a separate constant or reference to the default value)
            const defaultQuantity = infoData[index].rbqty;

            // Ensure the entered value is not greater than the default quantity
            const newQuantity = Math.min(numericValue, defaultQuantity);

            // Update the rbqty state with the new quantity
            const updatedRbqty = [...rbqty];
            updatedRbqty[index] = newQuantity;
            setRbqty(updatedRbqty);  // Update the state with new quantity

        }
    };

    const tableContainerStyle = {
        marginTop: '1%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',
        overflowY: 'hidden',
        WebkitOverflowScrolling: 'touch',
    };

    function convertIntoOneObject(formData, infoData, rbqty) {
        var streId = 0;
        if (formData.streId !== '') {
            streId = formData.streId;
        } else if (formData.stchtopk !== '') {
            streId = formData.stchtopk
        }
        const department = departlist?.data?.length > 0 ? departlist.data.find((item) => item.departNm == formData.departNm) : null;
        const departId = departlist && department !== null ? department.ID : '0';

        const data = {
            dt: formData.dt,
            stkMemo: formData.stkMemo,
            departNm: formData.departNm,
            departId: departId,
            streId: streId,
            cutreId: formData.cutreId,
            empId: formData.empId,
            empNm: formData.empNm,
            itemId: formData.itemId,
            itemNm: formData.item,
            mcloth: formData.mcloth,
            m1cloth: formData.m1cloth,
            m2cloth: formData.m2cloth,
            m3cloth: formData.m3cloth,
            soId: formData.soId,
            sono: formData.sono,
            userId: formData.userId,
            infoData: infoData,
            rbqty: rbqty,
            clothNm: formData.clothNm,
            model: formData.model,
            color: formData.color,
            shadeNo: formData.shadeNo,
            icode: formData.icode
        };
        return data;
    };

    const departmentConfig = {
        'STITCHING': {
            label: 'Stitching Return No.',
            id: 'streId',
            options: filteredStitchingReturn,
            value: formData.streId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'streId', value: newValue ? newValue.ID : '' } }, 'streId'),
            getOptionLabel: (option) => option.stMemo || '',  // Dynamically pass `getOptionLabel`
            isOptionEqualToValue: (option, value) => option.ID === value.ID,  // Dynamically pass `isOptionEqualToValue`
            valueFinder: (options, value) => options.find(item => item.ID === value) || null,  // Dynamically pass `valueFinder`
        },
        'CUT-TO-PACK': {
            label: 'Cutting Return No.',
            id: 'cutreId',
            options: filteredCutToPack,
            value: formData.cutreId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'cutreId', value: newValue ? newValue.ID : '' } }, 'cutreId'),
            getOptionLabel: (option) => option.cutMemo || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => options.find(item => item.ID === value) || null,
        },
        'STITCH-TO-PACK': {
            label: 'Stitching Return No.',
            id: 'stchtopk',
            options: filteredStitchtoPack,
            value: formData.stchtopk,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'stchtopk', value: newValue ? newValue.ID : '' } }, 'stchtopk'),
            getOptionLabel: (option) => option.stMemo || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => options.find(item => item.ID === value) || null,
        },
    };

    // Get the department's config based on formData.departNm
    const department = departmentConfig[formData.departNm];

    const fields = [
        { label: 'Date', name: 'dt', type: 'date' },
        { label: 'Stock Memo', name: 'stkMemo', type: 'readOnly' },
    ];

    const handleSubmit = (e) => {
        e.preventDefault();
        // const validationErrors = validate();
        // if (Object.keys(validationErrors).length > 0) {
        //     setErrors(validationErrors);
        //     return;
        // }
        const finalObject = convertIntoOneObject(formData, infoData, rbqty);
        // console.log(finalObject)

        dispatch(insertStockEntryProduction(finalObject))
            .unwrap()
            .then((result) => {
                // Handle success
                console.log('POST request successful!', result);
                alert("Records Inserted");
                window.location.reload();
            })
            .catch((error) => {
                // Handle error
                console.error('Error while making POST request:', error);
                // You may want to display an error message to the user or perform any other action
            });
    };
    return (
        <>
            <TitleBar data={StockMenu} />
            <div style={{ margin: '1% 0.5%' }}>
                <h2>Stock Entry Production Wise</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={0.5}>

                                {fields.map((field) => (
                                    <DateInputComponent
                                        key={field.name}
                                        formData={formData}
                                        handleDateChange={handleDateChange}
                                        handleInputChange={handleInputChange}
                                        styled={styled}
                                        inputStyles={inputStyles}
                                        isDesktop={isDesktop}
                                        field={field}
                                    />
                                ))}


                                <Dropdown
                                    label="Department"
                                    id="departNm"
                                    options={filteredDepart}  // Ensure this is an array of objects [{ departNm: 'Sales' }, ...]
                                    value={filteredDepart.find(item => item.departNm === formData.departNm) || null}  // Make sure the value is an object
                                    onChange={(newValue) => {
                                        handleDropdownChange({ target: { name: 'departNm', value: newValue ? newValue.departNm : '' } }, 'departNm');
                                    }}
                                    isDesktop={isDesktop}
                                    getOptionLabel={(option) => option.departNm || ''}
                                    isOptionEqualToValue={(option, value) => option.departNm === value.departNm}  // Compare the `departNm` field
                                    valueFinder={(options, value) => options.find(item => item.departNm === value.departNm)}  // Match by `departNm`
                                />


                                {
                                    department && (
                                        <Dropdown
                                            label={department.label}
                                            id={department.id}
                                            options={department.options}
                                            value={department.value}
                                            onChange={department.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={department.getOptionLabel}
                                            isOptionEqualToValue={department.isOptionEqualToValue}
                                            valueFinder={department.valueFinder}  // Pass `valueFinder` function here
                                        />
                                    )
                                }

                                {Array.isArray(infoData) && infoData.length > 0 &&
                                    <>
                                        <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                                            <Table style={isDesktop ? { width: '70%' } : { width: '100%' }}>
                                                <TableBody>

                                                    <TableRow>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Sr.No.</TableCell>
                                                        {/* <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Barcode</TableCell> */}
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Item</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Color</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Size</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Qty</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Inw. Qty</TableCell>
                                                    </TableRow>
                                                    {
                                                        infoData.map((item, index) => (
                                                            <TableRow key={index}>

                                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' >{index + 1}</TableCell>
                                                                {/* <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' >{item.barcode}</TableCell> */}
                                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' >{formData.item}</TableCell>
                                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' >{formData.color}</TableCell>
                                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' >{item.size}</TableCell>
                                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' >{item.rbqty}</TableCell>
                                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                    <input
                                                                        type="text"
                                                                        value={rbqty[index]}  // Ensure value is either the number or an empty string
                                                                        name="rbqty"
                                                                        style={{ width: '50px', padding: '1px' }}
                                                                        onChange={(e) => handleQuantityChange(index, e.target.value)}  // Handle input event for real-time validation
                                                                    />
                                                                </TableCell>
                                                            </TableRow>
                                                        ))
                                                    }
                                                </TableBody>
                                            </Table>
                                        </TableContainer>

                                    </>
                                }

                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit}>Submit</Button>
                                </Grid>

                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default StkProductionEntry;
